define('vspot-angular/services/school-service',[], function () {
    'use strict';

    return ['$http', 'services.User', 'resources.School', function ($http, User, School) {

        return {
            /*
             *  Gets a list of all schools within a certain
             *  area, based on zip code.
             *
             *  @param  zipcode - A five digit number
             *  @param  radius  - A number, measured in miles
             *
             *  @returns  Resource object. See /resources.js documentation for details
             *            Expected return data: { status: boolean,
             *                                    zips: array_of_zips,
             *                                    num_of_zips: array_of_zips.size,
             *                                    num_of_schools: array_of_schools.size,
             *                                    schools: array_of_schools }
             */
            query: function(zipcode, radius) {
                return School.query({ zipcode: zipcode, radius: radius });
            },

            /*
             * get:
             *      Retrieve a single school.
             *
             * @param {int} id  = id of the school to retrieve
             * @returns Resource object
             */
            get: function (id) { 
                return School.get({id: id});
            }
        };
    }];
});

